import * as Yup from 'yup'

export const subscriptionPriceSchema = Yup.object().shape({
  type: Yup.string().required('validation-required'),
  amount: Yup.number().required('validation-required'),
  months: Yup.number().required('validation-required'),
  default: Yup.boolean().required('validation-required'),
})
